import { createProductStore } from "@project/emerge";
import type { AbstractPartDefinition } from "@project/emerge-types";
import type { LTProducts } from "./enum/LTProducts";
import type { FlightCaseBlueprint } from "./interfaces/FlightCaseBlueprint";
import type { FlightCaseSettings } from "./interfaces/FlightCaseSettings";

export const useFlightCaseViewer = createProductStore<
  LTProducts,
  FlightCaseSettings,
  FlightCaseBlueprint,
  AbstractPartDefinition<string>
>();
